export default __webpack_public_path__ + "static/media/Nj_Police.909292ac.png";